export class Cache<T> {
  private cache: Map<string, { data: T; timestamp: number }> = new Map();
  private ttl: number;

  constructor(ttlInSeconds: number = 300) { // 5 minutes default TTL
    this.ttl = ttlInSeconds * 1000;
  }

  public set(key: string, data: T): void {
    this.cache.set(key, {
      data,
      timestamp: Date.now(),
    });
  }

  private getCached(key: string): T | null {
    const item = this.cache.get(key);
    if (!item) return null;

    const isExpired = Date.now() - item.timestamp > this.ttl;
    if (isExpired) {
      this.cache.delete(key);
      return null;
    }

    return item.data;
  }

  async get(key: string, getter: () => Promise<T>): Promise<T | null> {
    const cached = this.getCached(key);
    if (cached) return cached;

    try {
      const data = await getter();
      if (data) {
        this.set(key, data);
      }
      return data;
    } catch (error) {
      console.error(`Cache fetch error for key ${key}:`, error);
      return null;
    }
  }

  clear(): void {
    this.cache.clear();
  }
} 